import { landingPageSlice } from './reducer';

export const { setLandingPage, fetchLandingPageRequest, resetLandingPage } = landingPageSlice.actions;
